import { Link } from 'react-router-dom';

const CLIENTS = [
  { name: 'TechCorp Global', sector: 'Technology' },
  { name: 'Maritime Logistics Co.', sector: 'Shipping' },
  { name: 'EduTech Academy', sector: 'Education' },
  { name: 'RetailPlus Group', sector: 'Retail' },
  { name: 'HealthCare Systems', sector: 'Healthcare' },
  { name: 'BuildIt Construction', sector: 'Real Estate' },
  { name: 'FinServ Bank', sector: 'Finance' },
  { name: 'GovTech Solutions', sector: 'Government' },
];

const TESTIMONIALS = [
  {
    quote: 'Their AI-powered inventory system transformed our warehouse operations. Stock accuracy went from 82% to 99.4% within 3 months of deployment.',
    name: 'David Chen',
    role: 'COO, RetailPlus Group',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20executive%20businessman%20headshot%20portrait%20confident%20smile%20corporate%20attire%20white%20background%20clean%20professional%20photo&width=80&height=80&seq=avatar-dc&orientation=squarish',
  },
  {
    quote: 'The RFID Library Management System they built for us has completely automated our book tracking. Students love the self-checkout kiosks.',
    name: 'Sarah Mitchell',
    role: 'Director, EduTech Academy',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20educator%20director%20headshot%20portrait%20confident%20friendly%20smile%20corporate%20attire%20white%20background%20clean%20professional%20photo&width=80&height=80&seq=avatar-sm&orientation=squarish',
  },
  {
    quote: 'Outstanding Ship Chandling system — quotation turnaround dropped from 2 days to under 2 hours. Our suppliers are impressed too.',
    name: 'Capt. Ahmed Hassan',
    role: 'CEO, Maritime Logistics Co.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20male%20maritime%20executive%20captain%20headshot%20portrait%20confident%20professional%20attire%20white%20background%20clean%20photo&width=80&height=80&seq=avatar-ah&orientation=squarish',
  },
];

export default function HomeClients() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          {/* <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-4">
            Our Clients
          </span> */}
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900 mb-3">
            Trusted by Leading Organizations
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Over 25 years of delivering excellence to clients across industries worldwide.
          </p>
        </div>

        {/* Client Logos Strip */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-14">
          {CLIENTS.map((client) => (
            <div
              key={client.name}
              className="bg-white border border-gray-100 rounded-xl px-5 py-5 flex flex-col items-center justify-center text-center gap-1 hover:border-teal-200 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-xl mb-2">
                <i className="ri-building-2-line text-teal-600 text-xl" />
              </div>
              <div className="text-sm font-semibold text-gray-800">{client.name}</div>
              <div className="text-xs text-gray-400">{client.sector}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {TESTIMONIALS.map((t) => (
            <div key={t.name} className="bg-white border border-gray-100 rounded-2xl p-7">
              <div className="flex gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">&quot;{t.quote}&quot;</p>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-900">{t.name}</div>
                  <div className="text-xs text-gray-400">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/clients"
            className="cursor-pointer whitespace-nowrap inline-flex items-center gap-2 border border-teal-500 text-teal-600 hover:bg-teal-500 hover:text-white font-semibold px-7 py-3 rounded-lg transition-colors"
          >
            View All Clients <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
